const backgroundSrc = "/timer/red-curtains-bg.jpeg";

export default {
  id: 1,
  title: "模拟法庭计时器",
  pages: [
    {
      title: "封面",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "模拟法庭",
        },
        {
          type: "subtitle",
          subtitle: "模拟法庭计时器",
        },
      ],
    },
    {
      title: "开庭准备",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "开庭准备",
        },
      ],
    },
    {
      title: "身份核对、告知权利",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "身份核对",
        },
        {
          type: "title",
          title: "告知权利",
        },
      ],
    },
    {
      title: "法庭调查",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "法庭调查",
        },
        {
          type: "div",
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "stretch",
          },
          children: [
            [
              {
                type: "story",
                style: {
                  // border: 'solid 1px #DEAB7F',
                  height: "100%",
                  padding: "1vw 0",
                },

                story: [
                  {
                    type: "timers",
                    mode: "single",
                    theme: "lite",
                    rowSize: 2,
                    styles: {
                      fontSize: "4.6em",
                      color: "#F0F3EF",
                    },
                    list: [
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "公诉人<br>宣读起诉书",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "03:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "被告人、辩护人<br>答辩",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "03:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
    {
      title: "法庭调查",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "法庭调查",
        },
        {
          type: "div",
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "stretch",
          },
          children: [
            [
              {
                type: "story",
                style: {
                  // border: 'solid 1px #DEAB7F',
                  height: "100%",
                  padding: "1vw 0",
                },
                story: [
                  {
                    type: "timers",
                    mode: "single",
                    theme: "lite",
                    rowSize: 2,
                    styles: {
                      fontSize: "4.6em",
                      color: "#F0F3EF",
                    },
                    list: [
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "控方-举证质证",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "10:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "辩方-举证质证",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "19:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
    {
      title: "法庭调查",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "法庭调查",
        },
        {
          type: "div",
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "stretch",
          },
          children: [
            [
              {
                type: "story",
                style: {
                  // border: 'solid 1px #DEAB7F',
                  height: "100%",
                  padding: "1vw 0",
                },
                story: [
                  {
                    type: "timers",
                    mode: "single",
                    theme: "lite",
                    rowSize: 2,
                    styles: {
                      fontSize: "4.6em",
                      color: "#F0F3EF",
                    },
                    list: [
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "控方-举证质证小结",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "02:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "辩方-举证质证小结",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "02:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
    {
      title: "法庭辩论",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "法庭辩论",
        },
        {
          type: "div",
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "stretch",
          },
          children: [
            [
              {
                type: "story",
                style: {
                  // border: 'solid 1px #DEAB7F',
                  height: "100%",
                  padding: "1vw 0",
                },
                story: [
                  {
                    type: "timers",
                    mode: "single",
                    theme: "lite",
                    rowSize: 2,
                    styles: {
                      fontSize: "4.6em",
                      color: "#F0F3EF",
                    },
                    list: [
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "公诉意见",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "03:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "辩护词",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "03:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
    {
      title: "法庭辩论",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "法庭辩论",
        },
        {
          type: "div",
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "stretch",
          },
          children: [
            [
              {
                type: "story",
                style: {
                  // border: 'solid 1px #DEAB7F',
                  height: "100%",
                  padding: "1vw 0",
                },
                story: [
                  {
                    type: "timers",
                    mode: "single",
                    theme: "lite",
                    rowSize: 1,
                    styles: {
                      fontSize: "4.6em",
                      color: "#F0F3EF",
                    },
                    list: [
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "归纳辩论焦点",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "02:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
    {
      title: "法庭辩论",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "法庭辩论",
        },
        {
          type: "div",
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "stretch",
          },
          children: [
            [
              {
                type: "story",
                style: {
                  // border: 'solid 1px #DEAB7F',
                  height: "100%",
                  padding: "1vw 0",
                },
                story: [
                  {
                    type: "timers",
                    mode: "single",
                    theme: "lite",
                    rowSize: 2,
                    styles: {
                      fontSize: "4.6em",
                      color: "#F0F3EF",
                    },
                    list: [
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "控方-法庭辩论",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "14:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "辩方-法庭辩论",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "14:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
    {
      title: "法庭辩论",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "法庭辩论",
        },
        {
          type: "div",
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "stretch",
          },
          children: [
            [
              {
                type: "story",
                style: {
                  // border: 'solid 1px #DEAB7F',
                  height: "100%",
                  padding: "1vw 0",
                },
                story: [
                  {
                    type: "timers",
                    mode: "single",
                    theme: "lite",
                    rowSize: 2,
                    styles: {
                      fontSize: "4.6em",
                      color: "#F0F3EF",
                    },
                    list: [
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "控方-辩论总结",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "02:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "辩方-辩论总结",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "02:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
    {
      title: "最后陈述",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "最后陈述",
        },
        {
          type: "div",
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "stretch",
          },
          children: [
            [
              {
                type: "story",
                style: {
                  // border: 'solid 1px #DEAB7F',
                  height: "100%",
                  padding: "1vw 0",
                },
                story: [
                  {
                    type: "timers",
                    mode: "single",
                    theme: "lite",
                    rowSize: 2,
                    styles: {
                      fontSize: "4.6em",
                      color: "#F0F3EF",
                    },
                    list: [
                      {
                        duration: "02:00",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
    // 评判提醒：校赛没有，上海市有
    {
      title: "评判提醒",
      background: "imageCover",
      backgroundSrc,
      theme: "dark",
      components: [
        {
          type: "title",
          title: "评判提醒",
        },
        {
          type: "div",
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "stretch",
          },
          children: [
            [
              {
                type: "story",
                style: {
                  // border: 'solid 1px #DEAB7F',
                  height: "100%",
                  padding: "1vw 0",
                },
                story: [
                  {
                    type: "timers",
                    mode: "single",
                    theme: "lite",
                    rowSize: 2,
                    styles: {
                      fontSize: "4.6em",
                      color: "#F0F3EF",
                    },
                    list: [
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "辩方发言",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "02:30",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                      {
                        titleSlot: [
                          {
                            type: "sectionTitle",
                            title: "控方发言",
                            fontSize: "0.5em",
                          },
                        ],
                        duration: "02:30",
                        mode: "countdown",
                        format: "mm:ss",
                        layout: "vertical",
                        numberTheme: "number-plain",
                        blinkAt: "00:31",
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
  ],
};
